import React from "react";
import _ from "lodash";
import FiltersContainer from "./filters/FiltersContainer";
import FiltersPopup from "./filters/FiltersPopup";
import PhotosContainer from "./results/PhotosContainer";
import { Photo, Filters, Cart } from "./types";

interface ResultContainerProps {
  photosAPI: string;
  addPhotoToCart: (photo: Photo) => void;
  removePhotoFromCart: (photo: Photo) => void;
  cart: Cart;
  initialFilters: Filters;
  updateImageFilter: (imageUrl: string, clearSelfie: boolean) => void;
}

interface ResultContainerState {
  filterSelections: Filters;
  filterOptions: {
    photographers: [];
  };
  filtersPopup: boolean;
}

class ResultContainer extends React.Component<
  ResultContainerProps,
  ResultContainerState
> {
  constructor(props: ResultContainerProps) {
    super(props);

    this.state = {
      filterSelections: {
        ...defaultFilters,
        ...props.initialFilters
      },
      filterOptions: {
        photographers: []
      },
      filtersPopup: false
    };

    this.updateFilters = this.updateFilters.bind(this);
    this.resetFilter = this.resetFilter.bind(this);
    this.updateFilterOptions = this.updateFilterOptions.bind(this);
  }

  public componentWillReceiveProps(nextProps: ResultContainerProps) {
    if (
      !_.isEqual(
        this.state.filterSelections.referenceImage,
        nextProps.initialFilters.referenceImage
      )
    ) {
      this.setState({
        filterSelections: {
          ...this.state.filterSelections,
          referenceImage: nextProps.initialFilters.referenceImage
        }
      });
    }
  }

  public render() {
    return (
      <div className="dv-maincontent dv-galsection-empty selfie-searched">
        <div className="container">
          <div className="row dv-events-wrap">
            <div className="col-md-3 text-left hidden-xs hidden-sm">
              <FiltersContainer
                filterSelections={this.state.filterSelections}
                updateFilters={this.updateFilters}
                resetFilter={this.resetFilter}
                updateImageFilter={this.props.updateImageFilter}
              />
            </div>
            <div className="col-md-9 dv-results">
              <PhotosContainer
                photosAPI={this.props.photosAPI}
                filters={this.state.filterSelections}
                cart={this.props.cart}
                addPhotoToCart={this.props.addPhotoToCart}
                removePhotoFromCart={this.props.removePhotoFromCart}
                updateFilterOptions={this.updateFilterOptions}
                openFiltersPopup={this.openFiltersPopup}
              />
            </div>
            {this.state.filtersPopup && (
              <FiltersPopup
                filterSelections={this.state.filterSelections}
                updateFilters={this.updateFilters}
                resetFilter={this.resetFilter}
                closePopup={this.closeFiltersPopup}
                updateImageFilter={this.props.updateImageFilter}
              />
            )}
          </div>
        </div>
      </div>
    );
  }

  private resetFilter() {
    this.setState({
      filterSelections: {
        confidenceLevel: 80,
        purchasedEventsFilter: true,
        referenceImage: null,
        photographers: []
      }
    });
  }

  private updateFilters(newFilters: Filters) {
    this.setState({
      filterSelections: newFilters
    });
  }

  private updateFilterOptions(newOptions: Filters) {
    this.setState({
      filterOptions: newOptions
    });
  }

  private openFiltersPopup = () => {
    this.setState({ filtersPopup: true });
  };

  private closeFiltersPopup = () => this.setState({ filtersPopup: false });
}

export default ResultContainer;

const defaultFilters = {
  photographers: [],
  purchasedEventsFilter: true
};
